import { createSelector } from 'reselect';
import { currency } from '../../helpers/numberFormatter';
import { instrumentsWithProductFullNamesAndProductSymbols } from './instrumentPositionSelectors';
import { isMarginActiveSelector } from './marginSelectors';
export var recentTradesSelector = createSelector([function (state) {
  return state.recentTrades;
}, instrumentsWithProductFullNamesAndProductSymbols, function (state) {
  return state.apexCore.instrument.selectedInstrumentId;
}, function (state) {
  return state.margin.instrument.selectedInstrumentId;
}, isMarginActiveSelector], function (recentTrades, instruments, standardInstrumentId, marginInstrumentId, isMarginActive) {
  var selectedInstrumentId = isMarginActive ? marginInstrumentId : standardInstrumentId;
  var tradesByInstrument = recentTrades[selectedInstrumentId];
  var instrument = instruments.find(function (item) {
    return item.InstrumentId === selectedInstrumentId;
  });
  if (!instrument || !tradesByInstrument) {
    return [];
  }
  var Product1Symbol = instrument.Product1Symbol,
    Product2Symbol = instrument.Product2Symbol;
  return tradesByInstrument.map(function (trade) {
    var quantity = currency(trade.Quantity, Product1Symbol);
    var price = currency(trade.Price, Product2Symbol);
    return Object.assign({}, trade, {
      Quantity: quantity,
      Price: price
    });
  });
});